<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Font Material </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'baseMaterial'" [label]="'Base Material'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'text'" [label]="'Text'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'alignment'" [label]="'Alignment'" [selectionPossibilities]="$alignmentOptions()"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'spacing'" [label]="'Spacing'" [decimalPlaces]="0"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'glyphHeightCm'" [label]="'Font Height (cm)'" [decimalPlaces]="2"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'stamped'" [label]="'Stamped'"></cm-value-slot>
        @if ($parameters().stamped) {
            <cm-value-slot
                [node]="$node()"
                [key]="'lightAngle'"
                [label]="'Light Angle'"
                [decimalPlaces]="0"
                [numberModifier]="'slider'"
                [min]="0"
                [max]="360"
            ></cm-value-slot>
            <cm-value-slot
                [node]="$node()"
                [key]="'shadowStrength'"
                [label]="'B Strength'"
                [decimalPlaces]="2"
                [numberModifier]="'slider'"
                [min]="0"
                [max]="10"
            ></cm-value-slot>
            <cm-value-slot
                [node]="$node()"
                [key]="'lightStrength'"
                [label]="'W Strength'"
                [decimalPlaces]="2"
                [numberModifier]="'slider'"
                [min]="0"
                [max]="10"
            ></cm-value-slot>
            <cm-value-slot
                [node]="$node()"
                [key]="'embossingSteepness'"
                [label]="'Steepness'"
                [decimalPlaces]="2"
                [numberModifier]="'slider'"
                [min]="0"
                [max]="10"
            ></cm-value-slot>
            <cm-value-slot
                [node]="$node()"
                [key]="'embossingOffset'"
                [label]="'Offset'"
                [decimalPlaces]="2"
                [numberModifier]="'slider'"
                [min]="-10"
                [max]="10"
            ></cm-value-slot>
        }
    </ng-container>
</cm-inspector-section>

<cm-inspector-section [collapsible]="true">
    <ng-container cm-title> Glyphs </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'glyphImage'" [label]="'Image'"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'glyphsConfiguration'" [label]="'Letters'" [decimalPlaces]="0"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
